import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    applicantId: string;
};

export const schemaLoanRequestResolver_IsApplicantEmailVerified = z.boolean();

export type SchemaLoanRequestResolver_IsApplicantEmailVerified = z.infer<
    typeof schemaLoanRequestResolver_IsApplicantEmailVerified
>;

export type LoanRequestResolver_IsApplicantEmailVerified = Resolver<
    Arguments,
    SchemaLoanRequestResolver_IsApplicantEmailVerified
>;
